// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Pdf: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 38 51"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path
                fillRule="evenodd"
                d="M21.697 0v15.203c0 .536.438.971.978.971H38v31.912C38 49.688 36.68 51 35.068 51H2.932C1.319 51 0 49.688 0 48.086V2.914C0 1.311 1.32 0 2.932 0h18.765zm12.638 22.615h-7.712v15.27h3.607v-6.498h3.518v-2.623H30.23v-3.526h4.105v-2.623zm-15.188 0h-4.193v15.27h4.544c3.959 0 5.366-2.214 5.366-5.915v-3.935c0-3.847-1.964-5.42-5.717-5.42zm-10.908 0H3.665v15.27h3.577v-5.799h.938c3.284 0 5.396-1.34 5.396-4.808 0-3.352-2.2-4.663-5.337-4.663zm11.289 2.623c.056 0 .11.001.164.005l.028.002.126.013.092.016.052.01.108.027.023.006.11.039.02.007.04.018.064.029.013.006.098.055.011.007.04.027.05.036.01.006.022.018.065.054c.036.033.064.061.09.09l.04.047.036.043c.027.034.05.067.073.1v.005l.063.1.004.007.053.105.006.014.012.028.032.074.009.024.027.076.008.022.005.015.006.02.028.092.012.052.006.024.008.029.007.026.014.07.013.065.007.043.004.02.005.032.007.044.015.122.003.021v.013l.014.133-.001.007.006.095v.003l.004.043v.042l.005.11V27.545l.002.081v5.13c0 .048 0 .098-.002.147l-.001.016-.005.131-.007.096-.003.051a4.745 4.745 0 01-.014.147l-.003.024-.016.121-.016.096-.007.048a3.682 3.682 0 01-.03.14l-.006.024-.027.115-.028.093-.012.041a2.74 2.74 0 01-.045.13l-.014.03-.038.097-.05.102-.008.019a2.02 2.02 0 01-.064.115l-.038.059-.033.05c-.025.036-.05.07-.078.103l-.031.035-.054.06a1.407 1.407 0 01-.417.299l-.008.002-.117.049a1.65 1.65 0 01-.427.089l-.16.006H18.5V25.238zm-11.611-.03c1.407 0 2.052.729 2.052 2.157 0 1.486-.821 2.157-2.258 2.157h-.469v-4.314zM24.923 0L38 12.968H25.9a.975.975 0 01-.977-.971V0z"
            />
        </svg>
    );
};

export default React.memo(Pdf);
